import Style from "./logo.module.scss";
import tawaLogo from "../../../assets/images/tawa-logo.png";

export const Logo = () => {
  return (
    <img
      src={tawaLogo}
      alt="Tawa"
      data-testid="app-logo-tawa"
      className={Style.logoImage}
    />
  );
};
